import { EVENT_STATUS_CLOSED, EVENT_STATUS_FINALIZED } from '@ogsnetwork/opp-api-lib';
import { clearTicketErrors, editPropBetTicket, fetchBets, fetchCurrentCustomer, fetchSelections, purchasePropBetTicket } from '@ogsnetwork/opp-redux-lib';
import { useEffect, useState } from 'react';
import { useAppDispatch, useAppSelector, usePrevious } from '../index';
export function useDraftPropBet(props) {
    var _a, _b;
    const dispatch = useAppDispatch();
    const bets = useAppSelector((state) => {
        var _a;
        if (props.event) {
            return ((_a = state.bets.byEventGameId[props.event.externalId]) !== null && _a !== void 0 ? _a : []).map((betId) => state.bets.byId[betId]);
        }
        return [];
    });
    const selectionsById = useAppSelector((state) => state.selections.byId);
    const selectionsByTicketId = useAppSelector((state) => state.selections.byTicketId);
    const selectionsStatus = useAppSelector((state) => state.selections.status);
    const ticketStatus = useAppSelector((state) => state.tickets.status);
    const previousTicketStatus = usePrevious(ticketStatus);
    const tickets = useAppSelector((state) => state.tickets);
    const [selections, setSelections] = useState([]);
    const [selectionsByBetId, setSelectionsByBetId] = useState({});
    function save() {
        if (props.ticket) {
            const ticketSelectionIds = selectionsByTicketId[props.ticket.id];
            const deletedSelectionIds = [];
            const newSelections = [];
            selections.forEach((newSelection) => {
                if (typeof newSelection.id === 'undefined') {
                    newSelections.push(newSelection);
                }
                else if (!ticketSelectionIds.includes(newSelection.id)) {
                    newSelections.push(newSelection);
                }
                else {
                    const currentSelection = selectionsById[newSelection.id];
                    if (currentSelection.outcomeId !== newSelection.outcomeId ||
                        currentSelection.value !== newSelection.value ||
                        currentSelection.losingOutcomeId !== newSelection.losingOutcomeId) {
                        newSelections.push(newSelection);
                        deletedSelectionIds.push(newSelection.id);
                    }
                }
            });
            dispatch(editPropBetTicket({ ticketId: props.ticket.id, deletedSelectionIds, newSelections }));
        }
        else if (props.event) {
            dispatch(purchasePropBetTicket({
                eventId: props.event.id,
                selections
            }));
        }
    }
    useEffect(() => {
        var _a;
        setSelections((_a = props.selections) !== null && _a !== void 0 ? _a : []);
        return () => {
            dispatch(clearTicketErrors());
        };
    }, []);
    useEffect(() => {
        if (props.event) {
            dispatch(fetchBets(parseInt(props.event.externalId, 10)));
            if (props.ticket) {
                dispatch(fetchSelections(props.ticket.id));
            }
        }
    }, [(_a = props.event) === null || _a === void 0 ? void 0 : _a.id]);
    useEffect(() => {
        if (selectionsStatus === 'success') {
            const selectionIds = props.ticket ? selectionsByTicketId[props.ticket.id] : [];
            let ticketSelectionsByBetId = {};
            if (typeof selectionIds !== 'undefined') {
                ticketSelectionsByBetId = selectionIds.reduce((reducerSelectionsById, selectionId) => {
                    const selection = selectionsById[selectionId];
                    if (selection.betId) {
                        reducerSelectionsById[selection.betId] = selection;
                    }
                    return reducerSelectionsById;
                }, {});
            }
            setSelectionsByBetId(ticketSelectionsByBetId);
        }
    }, [selectionsStatus]);
    useEffect(() => {
        var _a, _b;
        if (ticketStatus === 'success' && previousTicketStatus === 'purchasing') {
            dispatch(fetchCurrentCustomer());
            (_a = props === null || props === void 0 ? void 0 : props.onPurchase) === null || _a === void 0 ? void 0 : _a.call(props);
            props.onSave();
        }
        if (ticketStatus === 'success' && previousTicketStatus === 'editing') {
            if (props.ticket) {
                dispatch(fetchSelections(props.ticket.id));
            }
            (_b = props === null || props === void 0 ? void 0 : props.onEdit) === null || _b === void 0 ? void 0 : _b.call(props);
            props.onSave();
        }
        if (ticketStatus === 'error') {
        }
    }, [ticketStatus]);
    useEffect(() => {
        if (props.ticket) {
            dispatch(fetchSelections(props.ticket.id));
        }
    }, [props.ticket]);
    useEffect(() => {
        var _a, _b;
        if (((_a = props.event) === null || _a === void 0 ? void 0 : _a.status) === EVENT_STATUS_CLOSED) {
            props.onEventClose();
        }
        else if (((_b = props.event) === null || _b === void 0 ? void 0 : _b.status) === EVENT_STATUS_FINALIZED) {
            props.onEventFinalize();
        }
    }, [(_b = props.event) === null || _b === void 0 ? void 0 : _b.status]);
    useEffect(() => {
        const filteredSelections = Object.values(selectionsByBetId).filter((selection) => selection.value !== undefined || selection.outcomeId !== undefined);
        setSelections(filteredSelections);
    }, [selectionsByBetId]);
    return {
        bets,
        save,
        error: tickets.error,
        selections,
        selectionsByBetId,
        setSelectionsByBetId,
        ticketStatus
    };
}
